// app.js
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import CommonView from './views/common';
import PremiumView from './views/premium';

const AppView = Backbone.View.extend({
  initialize: function () {
    this.render();
  },
  render: function () {
    let common_view = new CommonView();
    let premium_view = new PremiumView();
  },
});

export default AppView;